import { render, staticRenderFns } from "./OnboardingDeployFromGitModal.vue?vue&type=template&id=8ca588d6&scoped=true"
import script from "./OnboardingDeployFromGitModal.vue?vue&type=script&lang=js"
export * from "./OnboardingDeployFromGitModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingDeployFromGitModal.vue?vue&type=style&index=0&id=8ca588d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca588d6",
  null
  
)

export default component.exports